module.exports = __webpack_public_path__ + "static/img/gaOngJwsRYRaVAuXXcmB.c9297581.png";